import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Context } from 'src/app/api/models/context.model';
import { State } from 'src/app/core/state/core.state';
import { ROOT_PATH, START_PATH } from 'src/app/shared/constants/route.constants';

@Component({
  selector: 'app-context',
  template: ''
})
export class ContextComponent implements OnInit {
  public Context?: Context;
  constructor(private route: ActivatedRoute, private router: Router, private store: Store<State>) {}
  ngOnInit(): void {
    this.Context = this.route.snapshot.data['context'] as Context;
    this.store.dispatch({ type: '[Store] Reset' });
    localStorage.setItem('context', JSON.stringify(this.Context));
    this.router.navigate([`${ROOT_PATH}${START_PATH}`, this.Context.token]);
  }
}
